export default __webpack_public_path__ + "static/media/mute.b142aa46.svg";